import { reactive } from "vue";

export const openCollection = reactive({
    open: false
});

export const openBranches = reactive({
    open: false
});